import React from 'react';
import { Shield, Truck, RefreshCw, Headphones } from 'lucide-react';

const features = [
  {
    icon: <Truck size={28} />,
    title: 'Envío a todo Chile',
    desc: 'Despacho express disponible a Regiones',
  },
  {
    icon: <Shield size={28} />,
    title: 'Pago 100% seguro',
    desc: 'MercadoPago y más métodos de pago',
  },
  {
    icon: <RefreshCw size={28} />,
    title: 'Devolución fácil',
    desc: '30 días para cambios y devoluciones',
  },
  {
    icon: <Headphones size={28} />,
    title: 'Soporte 24/7',
    desc: 'Te atendemos por WhatsApp siempre',
  },
];

export default function Banner() {
  return (
    <>
      {/* Features strip */}
      <section style={{
        background: 'var(--green-pale)',
        borderTop: '2px solid var(--green-border)',
        borderBottom: '2px solid var(--green-border)',
        padding: '40px 20px',
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: '32px',
        }}>
          {features.map((f, i) => (
            <div key={i} style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '16px',
              animation: `fadeInUp 0.5s ease ${i * 0.1}s both`,
            }}>
              <div style={{
                background: 'var(--green-dark)',
                color: 'white',
                borderRadius: '14px',
                padding: '12px',
                flexShrink: 0,
              }}>
                {f.icon}
              </div>
              <div>
                <div style={{ fontWeight: 800, color: 'var(--green-dark)', marginBottom: '4px' }}>
                  {f.title}
                </div>
                <div style={{ fontSize: '13px', color: 'var(--gray-600)', lineHeight: 1.4 }}>
                  {f.desc}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

    </>
  );
}
